'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  menu = [{
    title: 'Home',
    url: 'main'
  }];

  isCollapsed = true;

  constructor(FB, $firebaseAuth, $state, $cookies, $scope, $rootScope, userService) {
    'ngInject';

    this.isLoggedIn = FB.isLoggedInSync;
    this.userService = userService;
    this.$scope = $scope;
    // this.$scope.currentUser = {};

    
    this.getCurrentUser = FB.getCurrentUserSync;
    this.$firebaseAuth = $firebaseAuth();
    this.$state = $state;
    this.$cookies = $cookies;
    this.isAdmin = FB.isAdminSync;
    
    /**
     * Navigation Items
     * @title: Navigation link title
     * @url: Url for navigation link
     * @dropdown: false or true (sets whether items is a dropdown button or not)
     * @show: allViews (show whether logged in or not), loggedIn (show only when logged in), loggedOut (show only when logged out)
     */
    $scope.menu = [
      {
        title: 'Home',
        url: '/',
        dropdown: false,
        show: 'allViews'

      },
      {
        title: 'About',
        url: '/about',
        dropdown: false,
        show: 'allViews'

      },
      {
        title: 'Tools',
        url: '/',
        dropdown: true,
        show: 'loggedIn',
        subItem1: [
          {
            title: 'Dashboard',
            url: '/account/dashboard',
           
          },
          {
            title: 'Map',
            url: '/account/map'
          },
          {
            title: 'Parking',
            url: '/account/parking',
          },
          {
            title: 'Density',
            url: '/account/density',
          }, {
            title: 'Housing',
            url: '/account/housing',
            dropdown: true,
            show: 'loggedIn',
            subItem2: [
              {
                title: 'Housing Preservation',
                url: '/account/housing/housing_preservation',
              },
              {
                title: 'Housing Production',
                url: '/account/housing/housing_production',
              }, {
                title: 'Housing Protection',
                url: '/account/housing/housing_protection',
              },
              {
                title: 'Commercial Stabilization',
                url: '/account/housing/commercial_stabilization'
              }
            ]
          }, {
            title: 'Stations',
            url: '/account/stationaccess',
          }
        ]
      },
      {
        title: 'Account',
        url: '/',
        dropdown: true,
        show: 'loggedIn',
        subItem1: [
          {
            title: 'My Account',
            url: '/account/myaccount',
          },
          {
            title: 'Update Password',
            url: '/account/password'
          },
          {
            title: 'Logout',
            url: '/logout?main'
          },
        ]
      },
      // {
      //   title: 'Login',
      //   url: '/login',
      //   dropdown: false,
      //   show: 'loggedOut'
      // },
    ];

    $scope.adminMenu = [
      {
        title: 'Admin Tools',
        url: '/',
        dropdown: true,
        show: 'loggedIn',
        admin: true,
        subItem1: [
          {
            title: 'Manage Users',
            url: '/admin/manageusers',
            subItem2: [
              {
                title: 'Ultrabooks'
              },
              {
                title: 'Macbooks',
                subItem2: [
                  {
                    title: 'Alexis'
                  },
                  {
                    title: 'aNDREY'
                  }
                ]
              }
            ]
          },
          {
            title: 'Manage Stations',
            url: '/admin/stations'
          },
          {
            title: 'Manage Feedback',
            url: '/admin/feedback'
          },
        ]
      },
 
    ];

  }

  $onInit(){
    this.userService.getCurrentUser()
    .then(response => {
      this.$scope.currentUser = response.data;
      this.userService.setCurrentUser(response.data);
      
    })
    .catch(err => {
      console.log(err);
    })
  }
}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js